<template>
  <div>
    <div class="header" id="header">
      <div class="headerL">
        <img src="https://res.hntv.tv/icon/logo.png" alt="" />
        <div class="info">
          <p class="infoT">大象新闻APP</p>
          <p>脚踏实地做新闻</p>
        </div>
      </div>
      <div class="headerBtn">
        <button @click="wakeAppHandler">打开</button>
      </div>
    </div>
   </div>
</template>
<script>
import { wakeApp } from "@/utils/appMethods.js";
export default {
  data() {
    return {
      
    }
  },
  props: {
    articleId: {
      type: String,
      default:'',
    },
  },

  methods: {
    wakeAppHandler(){
      wakeApp(this.articleId)
    }
  },
};
</script>
<style lang="less" scoped>
.header {
  width: 750px;
  height: 90px;
  display: flex;
  padding: 0 12px;
  background-color: #f2f4f8;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  .headerL {
    display: flex;
    align-items: center;
    img {
      width: 80px;
      height: 80px;
      display: inline-block;
    }
    .info {
      display: inline-block;
      margin-left: 15px;
      font-size: 20px;
      p {
        margin: 10px 0;
        color: #999;
      }
      .infoT {
        font-size: 30px;
        font-weight: bold;
        color: #333;
      }
    }
  }
  .headerBtn {
    button {
      width: 165px;
      height: 62px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #036eb8;
      border-radius: 10px;
      font-size: 30px;
      color: #fff;
      text-align: center;
      border: none;
      outline: none;
    }
  }

  &.hidden {
    position: fixed;
    z-index: 9999;
    display: none;
    background-color: rgba(242, 244, 248, 0.75);
    bottom: 0;
  }
  &.visible {
    position: fixed;
    z-index: 9999;
    display: flex;
    background-color: rgba(242, 244, 248, 0.75);
    bottom: 0;
  }
}
</style>
